<template>
    <div>
        <div
            style="max-width: 100%; overflow: hidden;" 
            :class="[
                !imgHref ? 'n-image' : '',
                'form-image',
            ]">
            <div v-if="imgHref">
                <img :src="imgHref" @click="onImgClick" >
            </div>
            <input 
                class="abs-input"
                ref="theFile"
                type="file"
                accept=".gif,.jpg,.jpeg,.png,"
                @change="onFileChanged" >
        </div>
        <div>
        <button 
            @click="onImgClick"
            class="mt-6 bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">
            <span v-if="imgHref && imgHref != ''">Заменить изображение</span>
            <span v-else>Выбрать изображение</span>
        </button>
        </div>
            <!-- @input="$emit('update:modelValue', $event.target.value)"  -->
    </div>
</template>


<script>

export default {
    components: {},
    mounted() {
        this.imgHref = this.modelValue;
    },
    data () {
        return {
            imgHref: '',
        };
    },
    props: ['modelValue'],
    methods: {
        onFileChanged(e) {
            const input = e.target;
            var ext = input.files[0]['name'].substring(input.files[0]['name'].lastIndexOf('.') + 1).toLowerCase();
            const self = this;
            if (input.files && input.files[0] && (ext == "gif" || ext == "png" || ext == "jpeg" || ext == "jpg")) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    self.imgHref = e.target.result;
                    self.$emit('update:modelValue', input.files[0]);
                }
                reader.readAsDataURL(input.files[0]);
            }
        },
        onImgClick() {
            this.$refs.theFile.click();
        }
    },
}
</script>

<style scoped>
    .abs-input {
        position: absolute;
        left: -200%;
    }
</style>